var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 93H21C16.0375 93 12 88.9625 12 84V36C12 31.0375 16.0375 27 21 27H99C103.963 27 108 31.0375 108 36V84C108 88.9625 103.963 93 99 93ZM21 33C19.345 33 18 34.345 18 36V84C18 85.655 19.345 87 21 87H99C100.655 87 102 85.655 102 84V36C102 34.345 100.655 33 99 33H21Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 72H15V78H105V72Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93 57H57V63H93V57Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 45H57V51H84V45Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 63H33C28.0375 63 24 58.9625 24 54V51C24 46.0375 28.0375 42 33 42H36C40.9625 42 45 46.0375 45 51V54C45 58.9625 40.9625 63 36 63ZM33 48C31.345 48 30 49.345 30 51V54C30 55.655 31.345 57 33 57H36C37.655 57 39 55.655 39 54V51C39 49.345 37.655 48 36 48H33Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/Credit.84ad7897.svg";
export { ForwardRef as ReactComponent };